module.exports = __webpack_public_path__ + "static/media/ic_camera.8fd27f86.svg";